import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Usages_Reading_SaveRequestModel,
  ResponseModels_Readings_Summary_ReadingSummaryResponse,
  ResponseModels_Usages_Reading_ResponseModel,
  ResponseModels_Usages_Reading_SaveReadingResultResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetReading = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
};
/**
 * Gets the empty reading for an account of a customer.
 *
 * @returns ResponseModels_Usages_Reading_ResponseModel Success
 */
export function getReading(
  { businessUnit, label, customerId, accountId }: GetReading,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Reading_ResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/reading`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type SaveReading = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  requestBody?: RequestModels_Usages_Reading_SaveRequestModel;
};
/**
 * Save a reading for an account of a customer
 *
 * @returns ResponseModels_Usages_Reading_SaveReadingResultResponseModel Success
 */
export function saveReading(
  { businessUnit, label, customerId, accountId, requestBody }: SaveReading,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Reading_SaveReadingResultResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/reading`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type DownloadReadings = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  dateFrom: string;
  dateTo: string;
};
/**
 *
 *
 * @returns Blob Success
 */
export function downloadReadings(
  { businessUnit, label, customerId, accountId, dateFrom, dateTo }: DownloadReadings,
  requestConfig: ApiRequestConfig = {},
): Promise<Blob> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/readings/download`,
      query: { dateFrom, dateTo },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetReadingSummary = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Reading Summary for MVP Energy Monitor
 *
 * @returns ResponseModels_Readings_Summary_ReadingSummaryResponse Success
 */
export function getReadingSummary(
  { businessUnit, label, customerId }: GetReadingSummary,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Readings_Summary_ReadingSummaryResponse> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/readingsummary`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
